import { ArrowUpRight, FileSearch, Wind, Radar } from "lucide-react";
import Reveal from "@/components/landing/Reveal";
import { scrollToId } from "@/components/landing/Navbar";

const GROUPS = [
  {
    id: "versicherer",
    icon: FileSearch,
    title: "Versicherer & Gutachter",
    subtitle: "Schadensdokumentation",
    text: "Verwertbare Luftbilder und Berichte für Schadenfälle — schnell, nachvollziehbar und revisionssicher dokumentiert.",
  },
  {
    id: "industrie",
    icon: Wind,
    title: "Industrie & Energie",
    subtitle: "Anlagen-Inspektion",
    text: "Windkraft, Schornsteine, Funkmasten und Dächer: Zustandsprüfung ohne Gerüstbau und ohne Stillstand.",
  },
  {
    id: "einsatzkraefte",
    icon: Radar,
    title: "Einsatzkräfte & Kommunen",
    subtitle: "Technische Unterstützung",
    text: "Lagebilder, Suche und Aufklärung aus der Luft — als Technical First Responder an eurer Seite.",
  },
];

export default function Audience() {
  return (
    <section id="zielgruppen" data-testid="audience-section" className="relative">
      <div className="border-b border-white/10 px-6 py-20 lg:px-16 lg:py-28">
        <Reveal>
          <p className="font-tac text-xs tracking-[0.3em] text-[#F5B301]">IM EINSATZ FÜR</p>
          <h2 className="mt-6 font-display text-4xl font-black uppercase leading-[0.9] tracking-tighter sm:text-5xl lg:text-7xl">
            Wer darauf <span className="text-stroke">zählt.</span>
          </h2>
        </Reveal>
      </div>

      <div className="grid border-b border-white/10 lg:grid-cols-3">
        {GROUPS.map((group, i) => {
          const Icon = group.icon;
          return (
            <Reveal key={group.id} delay={i * 0.12} className="border-white/10 max-lg:border-b lg:[&:not(:last-child)]:border-r">
              <button
                data-testid={`audience-card-${group.id}`}
                onClick={() => scrollToId("#kontakt")}
                className="group relative flex h-full w-full flex-col items-start overflow-hidden p-10 text-left transition-colors duration-500 lg:p-14"
              >
                <span className="absolute inset-0 translate-y-full bg-[#F5B301] transition-transform duration-500 ease-[cubic-bezier(0.76,0,0.24,1)] group-hover:translate-y-0" />
                <span className="relative z-10 flex w-full items-start justify-between">
                  <Icon className="h-9 w-9 text-[#F5B301] transition-colors duration-500 group-hover:text-white" strokeWidth={1.5} />
                  <ArrowUpRight className="h-5 w-5 text-white/30 transition-all duration-500 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-white" />
                </span>
                <span className="relative z-10 mt-14 font-display text-4xl font-black uppercase tracking-tighter lg:text-5xl">
                  {group.title}
                </span>
                <span className="relative z-10 mt-2 font-tac text-[10px] uppercase tracking-[0.3em] text-white/50 transition-colors duration-500 group-hover:text-white/80">
                  {group.subtitle}
                </span>
                <span className="relative z-10 mt-6 max-w-xs font-tac text-xs leading-relaxed text-[#A1A1AA] transition-colors duration-500 group-hover:text-white">
                  {group.text}
                </span>
              </button>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
